<script setup lang="ts">
useHead({
  bodyAttrs: {
    class: "bg-[--theme-darkest]",
  },
})
</script>

<template>
  <div class="w-full xl:px-28 px-6 md:px-16 pt-6 lg:pt-16 flex justify-center">
    <div class="max-w-[1288px] w-full">
      <slot />
    </div>
  </div>
  <UBottomPanel />
</template>
